/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
export default angular.module('tektelic.components.textTruncateTooltip', [])
    .directive('tkTextTruncateTooltip', TextTruncateTooltip)
    .filter('count', CountCharacters)
    .name;

/*@ngInject*/
function TextTruncateTooltip($filter) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            function setOverflowFlag() {
                let visibleWidth = element[0].offsetWidth,
                    contentWidth = element[0].scrollWidth;
                if (contentWidth > visibleWidth) {
                    if ($filter('count')(element[0].dataset) == 0) {
                        element.attr("title", element[0].textContent)
                    } else if (element[0].hasOwnProperty('tooltip')) {
                        element.attr("title", "")
                    }
                } else {
                    element[0].tooltip = false;
                    element.removeAttr("title");
                }
            }
            element.bind('mouseover', setOverflowFlag);
        }
    }
}

/*@ngInject*/
function CountCharacters () {
    return function (value) {
        let count = 0;
        if (value) {
            if (angular.isArray(value) || angular.isString(value))
                count = value.length;
            else if (angular.isObject(value))
                count = Object.keys(value).length;
        }
        return count;
    };
}
/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/components/text-truncate-tooltip.js